var modules_211f87e9 = {"base-line":"_3gbp6p","container":"_44hn9z","inner":"_mj0r8 _3gbp6p","progress":"_9nt4b7 _3gbp6p"};
import "../../../assets/C6PirsLK.css";

export { modules_211f87e9 as default };
//# sourceMappingURL=Progress.module.less.js.map
